import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  Button,
  Container,
  Grid,
  Typography,
  FormControl,
  Box,
  CircularProgress,
  TextField
} from "@mui/material";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";

// ----------------------------------------------------------------------

export default function EditLeaguePage() {
  const fields = [
    { title: "Title", name: "title" },
    { title: "League Type", name: "league_type" }
  ];
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [league_id, setLeagueId] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    title: "",
    league_type: "",
    league_image_en: "",
    league_image_fr: "",
    league_image_sk: "",
    league_image_ee: "",
    league_image_lv: "",
    league_image_ru: "",
    league_image_nl: "",
    league_image_de: "",
    league_image_es: "",
  });

  const [isFilled, setFilling] = useState(true);

  useEffect(() => {
    if (searchParams.has("league_id")) {
      setLoading(true);

      let league_id = searchParams.get("league_id");
      setLeagueId(Number(league_id));

      const fetchDataLeagues = async () => {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/leagues/${league_id}`
        );
        setData(data?.league);
        return data;
      };
      fetchDataLeagues()
        .finally(() => setLoading(false))
    }
  }, [searchParams]);

  useEffect(() => {
    const count = Object.values(data).filter(
      (field) => field?.length <= 0
    ).length;
    if (count) setFilling(true);
    else setFilling(false);
  }, [data]);

  const handleChange = (event) => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = () => {
    if (!!data) {
      setLoading(true);
      axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/admin/leagues/${league_id}`,
          data
        )
        .then(function (response) {
          navigate("/dashboard/leagues");
        });
    }
  };
  return (
    <>
      <Helmet>
        <title> League </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Edit League
          </Typography>
        </Stack>

        <Card style={{ padding: 20 }}>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12}>
                {fields.map((field) => (
                  <FormControl
                    key={field.name}
                    sx={{ m: 1, minWidth: 620 }}
                    size="small"
                  >
                    <TextField
                      required
                      label={field.title}
                      placeholder={field.title}
                      name={field.name}
                      value={data[field.name] || ""}
                      onChange={(e) => handleChange(e)}
                      variant="outlined"
                    />
                  </FormControl>
                ))}
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Button
                  variant="contained"
                  disabled={!isFilled}
                  onClick={() => handleSubmit()}
                >
                  Edit
                </Button>
              </Grid>
            </Grid>
          )}
        </Card>
      </Container>
    </>
  );
}
